/**
 * Texts for Sam's review article
 */
export const samReviewText = {
    title: 'Sam and Sofia-Stevie - CamAPS FX',
    titleMeta: 'Rezension zu CamAPS FX von Sam und Sofia-Stevie lesen',
    descriptionMeta: 'CamAPS FX hat das Leben von Sam und Sofia-Stevie verändert, ' +
        'so dass sich Sam zum ersten Mal seit der Diagnose entspannen kann.',
    keywords:
        'camaps Rezension Sam and Sofia-Stevie, camaps fx Rezension Sam and Sofia-Stevie, ' +
        // 'type 1 diabetes, autoimmune disease, hyperglycemia, dexcom g6, type 1 diabetes symptoms, blood sugar monitor, diasend, insulin pump, diabetes type 1, blood glucose monitor, blood sugar, cgm, high blood sugar, type 1 diabetes causes, what is type 1 diabetes, diabetes in children, type 1, diabetes treatment, type 1 diabetes treatment, what is hypoglycemia, hypoglycemia treatment, jdrf, blood glucose meters, glucose monitor, type one diabetes, continuous glucose monitoring, type 1 diabetes in children, diabetes pump, t1d, closed loop system, diabetes machine, diabetic gastroparesis, diabetic hypoglycemia, diasend uk, diabetes 1, blood glucose monitor boots,  ' +
        '',
    localeMeta: 'de_de',

    imageTitle: 'Sam und Sofia-Stevie',
    shortIntroAndBody:
        '<h2>Ich kann mich zum ersten Mal seit der Diagnose entspannen</h2>' +
        '<p>' +
        'Ich habe vollstes Vertrauen in die CamAPS FX App und kann mich zum ersten Mal seit der Diagnose entspannen. Ohne jeden Zweifel hat sich die Zeit, die sich Sofia-Stevie im Blutzuckerzielbereich befindet, verbessert. ' +
        '</p>',
    body:
        '<h2>Ich kann mich zum ersten Mal seit der Diagnose entspannen</h2> ' +
        '<p> ' +
        '<strong> ' +
        'In den letzten zwei Jahren hat Sam, die Mutter von Sofia-Stevie (5 Jahre alt) die extrem steile Lernkurve ausgehalten, die alle Eltern von Kindern mit Typ-1-Diabetes durchmachen. Einen Sturm von Fingerstichtests, Injektionen und Sensoren später, hat sie nun die CamAPS FX App entdeckt und das hybride Closed-Loop System und möchte nicht mehr ohne sein. ' +
        '</strong> ' +
        '</p> ' +
        '<p> ' +
        'In einem heißen Sommer ist großer Durst nichts Ungewöhnliches für ein kleines Kind. Nichtsdestotrotz folgten Sam und ihre Mutter ihrer Intuition, dass etwas anderes dahinter stecken könnte und forschten nach, ob es Grund zur Besorgnis gibt, was schließlich zu Sofia-Stevies Diagnose von Typ-1-Diabetes führte. ' +
        '</p> ' +
        '<p> ' +
        '    <i> ' +
        '“Die Diagnose veränderte alles für immer; ich kann mich an die ersten Wochen erinnern, als sei es gestern gewesen. Ich hatte ich das Gefühl, als müsse ich quasi über Nacht zum Diabetesexperten werden, um mich richtig um meine kleine Tochter kümmern zu können. Sie hat absolute Priorität, so dass ich es einfach gemacht habe, und ich bin wirklich stolz auf mich und meine Mutter – sie war auf dieser Reise von Anfang an dabei.” ' +
        '    </i> ' +
        '</p> ' +
        '<h3> ' +
        '    Eine steile Lernkurve ' +
        '</h3> ' +
        '<p> ' +
        'Wie die meisten Eltern von neu diagnostizierten Kindern mit Typ-1-Diabetes, wurde Sam schnell Experte in Fingerstichtests, Dosierung von Basal- und Bolusinsulin und Maßnahmen, wenn die Tochter hypoglykämisch wurde. Seinem Kind Spritzen zu setzen, ist für alle Eltern eine Herausforderung, aber für Sam ganz besonders, weil sie Angst vor Nadeln überwinden musste. ' +
        '</p> ' +
        '<p> ' +
        '    <i> ' +
        '“Das klinische Team unterstützte mich hervorragend dabei, einige große Herausforderungen in diesen ersten Tagen zu meistern. Ich glaube nicht, dass wird dort wären, wo wir heute sind, wenn wir nicht die Unterstützung des klinischen Teams gehabt hätten.” ' +
        '    </i> ' +
        '</p> ' +
        '<p> ' +
        'In den ersten Monaten nach Sofia-Stevies Diagnose waren Fingerstichtests ein regelmäßiges Ereignis, um die Blutzuckerwerte über den Tag zu verstehen. Sam musste sich auch nachts den Wecker stellen, um die Blutzuckerwerte ihrer Tochter zu messen. Wenn Sofia-Stevies Werte hoch oder niedrig waren, musste Sam eine Korrekturdosis verabreichen und dann warten, bis sich die Werte in die richtige Richtung bewegten, bevor sie sich selbst wieder schlafen legen konnte – ein strapaziöser Prozess für beide, jede einzelne Nacht. ' +
        '</p> ' +
        '<p> ' +
        'Eines Tages erhielt Sofia-Stevie einen kontinuierlichen Glukosemesser (CGM), um die Behandlung zu unterstützen. Ein CGM ist ein kleines Gerät mit einem Sensor, der unter der Haut getragen wird, um die Blutzuckerwerte kontinuierlich zu messen. Sam betrachtete den CGM als Schritt in die richtige Richtung, insbesondere, weil sie mit dem Gerät nachts keinen Wecker mehr stellen musste – das Gerät würde sie automatisch alarmieren, wenn Sofia-Stevies Blutzuckerwerte außerhalb des Zielbereichs wären. Der CGM synchronisiert sich mit Sams Smartphone, so dass sie Sofia-Stevies Blutzuckerwerte in der Schule überprüfen kann, was auch den Lehrern bei der Betreuung tagsüber hilft. ' +
        '</p> ' +
        '<p> ' +
        '    Aber im Januar 2020 lernte Sam die CamAPS FX App kennen und hat seitdem nicht mehr zurückgeschaut. ' +
        '</p> ' +
        '<h3> ' +
        '    Freiheit finden ' +
        '</h3> ' +
        '<p> ' +
        ' Die CamAPS FX App wurde entwickelt, um zentrale Funktionen eines gesunden Pankreas nachzuahmen, ein sogenannter Hybrid-Closed-Loop Behandlungsansatz. Die App kommuniziert autonom mit dem CGM und der Insulinpumpe des Patienten und setzt einen komplexen Algorithmus ein, um die optimale Insulindosis alle 8-12 Minuten automatisch zu berechnen und zu verabreichen. ' +
        '</p> ' +
        '<p> ' +
        '    <i> ' +
        '“Ich hatte noch nie vom hybriden Closed-Loop System gehört oder der CamAPS FX App. Ich wusste nicht, wie das funktioniert, aber als das klinische Team nahelegte, dass es von Nutzen für uns wäre, sind wir mit zwei Füßen hineingesprungen. Bis dahin hatte ich so viel über Diabetes gelernt, dass sich das Lernen über hybriden Closed-Loop wie ein Spaziergang im Park anfühlte.” ' +
        '    </i> ' +
        '</p> ' +
        '<p> ' +
        '    <i> ' +
        '“Ich habe vollstes Vertrauen in die CamAPS FX App und ich kann mich zum ersten Mal seit der Diagnose entspannen. Ohne jeden Zweifel hat sich die Zeit, die sich Sofia-Stevie im Blutzuckerzielbereich befindet, verbessert. Es ist so viel einfacher geworden, ihre Werte zu kontrollieren und es ist eine schwere Last von meinen Schultern genommen worden. Es bedeutet auch weniger Belastung für ihre Lehrer und sehr viel weniger Sorge für mich. Ich kann aus der Ferne auf sie aufpassen, wenn ich möchte, aber ich habe zusätzlich die Sicherheit, dass ich automatisch Textnachrichten erhalte, wenn ihr Blutzucker hoch oder runter geht.” ' +
        '    </i> ' +
        '</p> ' +
        '<p> ' +
        '    <i> ' +
        '“Man kann keinen Unterschied zu ihren Klassenkameraden sehen, und das ist dank der CamAPS FX App möglich.” ' +
        '    </i> ' +
        '</p> ' +
        '<p> ' +
        'Sam ist mit ihrer Beobachtung über die Veränderungen durch die CamAPS FX App für sie und ihre Tochter nicht allein. Studien zeigen, dass die App den Schlaf von Heranwachsenden verbessert und ihnen das Gefühl gibt, normal aufzuwachen, was die Diabeteskontrolle am Tag verbessert sowie Konzentration und Wohlbefinden in der Schule. Zusätzlich waren Eltern, welche die App einsetzen, weniger ängstlich, was den Diabetes ihrer Kinder betrifft, und in der Folge konnten sie ihren Kindern größere Freiheit gewähren, wie beispielsweise mit Freunden spielen gehen, an Klassenausflügen teilnehmen und übernachten. ' +
        '</p> ' +
        '<p> ' +
        '    <i> ' +
        '“Es ist so sinnvoll für Kinder von Sofia-Stevies Alter ein Closed-Loop zu verwenden, weil das Ansprechen ihres Körper auf Insulin sich ständig verändert. Es ist eine sehr schwere Aufgabe für Eltern, die Situation ohne signifikante Hochs und Tiefs stets unter Kontrolle zu haben. Die App hingegen lernt und passt sich sofort an. Sie ist nützlich für das Langzeitmanagement der Erkrankung der Kinder und die Freiheit der Eltern, so dass sie nachts schlafen können.” ' +
        '    </i> ' +
        '</p> ' +
        '<h3> ' +
        '    Ich würde nie ohne die App sein wollen ' +
        '</h3> ' +
        '<p> ' +
        '    <i> ' +
        '“Ich würde nie ohne die App sein wollen. Sie passt auf einen auf und man muss sich keine Sorgen machen. Für jeden, der das in Erwägung zieht: Tu es. Sie ist ein Gamechanger und man schaut nicht mehr zurück oder will nicht ohne sein, wenn man sie einmal ausprobiert hat. Ich bin vollkommen überzeugt, dass das so nützlich für Eltern wie Kinder ist.” ' +
        '    </i> ' +
        '</p>'

};

/**
 * Texts for Roger's review article
 */
export const rogerReviewText = {
    title: 'Roger - CamAPS FX',
    titleMeta: 'Lesen Sie die Rezension zu CamAPS FX von Roger',
    descriptionMeta: 'Roger bemerkt, dass CamAPS FX von jedem und in jedem Alter verwendet werden kann.',
    keywords:
        'camaps Rezension Roger, camaps fx Rezension Roger, ' +
        // 'type 1 diabetes, autoimmune disease, hyperglycemia, dexcom g6, type 1 diabetes symptoms, blood sugar monitor, diasend, insulin pump, diabetes type 1, blood glucose monitor, blood sugar, cgm, high blood sugar, type 1 diabetes causes, what is type 1 diabetes, diabetes in children, type 1, diabetes treatment, type 1 diabetes treatment, what is hypoglycemia, hypoglycemia treatment, jdrf, blood glucose meters, glucose monitor, type one diabetes, continuous glucose monitoring, type 1 diabetes in children, diabetes pump, t1d, closed loop system, diabetes machine, diabetic gastroparesis, diabetic hypoglycemia, diasend uk, diabetes 1, blood glucose monitor boots,  ' +
        '',
    localeMeta: 'de_de',

    imageTitle: 'Roger',
    shortIntroAndBody:
        '<h2>Wenn ich es kann, kann es jeder</h2>' +
        '<p>' +
        'Es ist erstaunlich, wie sehr sich die Behandlung seit meiner Diagnose verändert hat, ich habe wirklich den Eindruck, dass ich von der Wüste in die digitale Welt gekommen bin. Für jeden, der den Einsatz der CamAPS FX App in Erwägung zieht, ist meine Empfehlung sehr einfach: Tu es! Es ist wirklich umwälzend, und wenn ich es kann, kann es jeder.' +
        '</p>',
    body:
        '<h2>Wenn ich es kann, kann es jeder</h2> ' +
        '<p> ' +
        '<strong> ' +
        'Als Erwachsener mit Typ-1-Diabetes diagnostiziert, hat der pensionierte Schulleiter Roger, 69 Jahre, die letzten 39 Jahre damit verbracht, seine Erkrankung besser zu verstehen. Er hat in dieser Zeit aus erster Hand die Veränderung in der Diabetestherapie erfahren, von Spritzen mit Glaskolben und dicken Nadeln, die in kochendem Wasser sterilisiert werden, bis zur CamAPS FX App und dem hybriden Closed-Loop System, ohne das er jetzt nicht mehr sein will.   ' +
        '</strong> ' +
        '</p> ' +
        '<p> ' +
        'Heutzutage wird Typ-1-Diabetes oft in der Kindheit diagnostiziert, aber bei Roger traten die Symptome erst mit 30 auf. Rogers Onkel und Schwiegermutter hatten schon Typ-1-Diabetes, so dass er mit dem Symptomen bereits vertraut war. ' +
        '</p> ' +
        '<p> ' +
        '    <i> ' +
        '“Ich erinnere mich lebhaft, dass ich gerade gefrühstückt hatte und einige Arbeiten im Garten erledigte. Ich ging zurück ins Haus und war sehr durstig. Ich stürzte einen halben Liter Fruchtsaft hinunter und meine Frau und ich sahen uns an und sagten gleichzeitig \'Diabetes\'. Mein Hausarzt brauchte etwas Überredung, aber ich wurde getestet und bekam die Bestätigung, dass ich Diabetiker bin.” ' +
        '    </i> ' +
        '</p> ' +
        '<p> ' +
        '    <i> ' +
        '“Zu dieser Zeit war das Wissen um Diabetes und seine Behandlung im Vergleich zu heute sehr begrenzt. Mir wurden einfach ein paar Spritzen aus Glas gegeben und mir wurde gesagt, wie ich die Kanülen in einem Topf mit kochendem Wasser sterilisiere und was meine Zielmenge an Insulin ist. Zum Glück hat mir meine Schwiegermutter ihr Diabeteshandbuch geliehen, und ich erinnere mich, dass ich mit meiner Frau in der Küche sitze, die das Buch aufhält, während ich mir selbst beibringe, wie man die Injektionen vornimmt.” ' +
        '    </i> ' +
        '</p> ' +
        '<h3> ' +
        'Nach besserer Kontrolle streben  ' +
        '</h3> ' +
        '<p> ' +
        'Während dieser ersten Jahre hat Roger sehr von den nationalen Diabetes-Patientenorganisationen profitiert, wo er zum Beispiel lernte, dass er mehr Insulin verabreichen muss, wenn er krank ist, was er vorher nicht wusste. Roger managte seine Erkrankung gut, aber dann wurden seine Blutzuckerwerte herausfordernder, weshalb er einen Kurs besuchte, in dem er lernte, die Insulinzufuhr seiner Diät und seinem Lebensstil anzupassen. Trotzdem erlebte Roger weiterhin schwere hypoglykämische Ereignisse.  ' +
        '</p> ' +
        '<p> ' +
        '    <i> ' +
        '“Ich passte auf meinen Enkelsohn auf und spielte mit ihm im Garten Fußball. Mein Schwiegersohn holte ihn ab und sagte plötzlich: \'Roger, sieh zu, dass Du etwas Saft trinkst.\' Natürlich habe ich einen Fingerstichtest durchgeführt und mein Blutzucker war sehr niedrig, ziemlich unterhalb dessen, wo er sein sollte. Ich sollte am folgenden Tag auf meinen Enkelsohn aufpassen, aber sie trafen andere Vereinbarungen. Sie dachten, mir gehe es nicht gut genug, um auf ihn aufzupassen, und das hat mich am Boden zerstört. Ich wusste, genug ist genug.” ' +
        '    </i> ' +
        '</p> ' +
        '<p> ' +
        'Nachdem Roger diese Geschichte seinem Berater erzählte, wurde er an ein Studienprojekt vermittelt, welches ungeklärte hypoglykämische Ereignisse untersucht. Er begann mit einer Insulinpumpentherapie. Die Pumpe verbesserte Rogers Blutzuckerwerte sofort. ' +
        '</p> ' +
        '<p> ' +
        'Da Roger so sehr vom ersten Studienprojekt profitierte, ergriff er sofort die Chance und startete mit der CamAPS FX App im Oktober 2019, als ihm die Möglichkeit angeboten wurde, an einer weiteren Studie teilzunehmen. ' +
        '</p> ' +
        '<p> ' +
        ' Die CamAPS FX App wurde entwickelt, um zentrale Funktionen eines gesunden Pankreas nachzuahmen, ein sogenannter hybrider Closed-Loop Behandlungsansatz. Die App kommuniziert autonom mit dem kontinuierlichen Glukosemonitor und der Insulinpumpe des Patienten und setzt einen komplexen Algorithmus ein, um die optimale Insulindosis alle 8-12 Minuten automatisch zu berechnen und zu verabreichen.' +
        '</p> ' +
        '<p> ' +
        '    <i> ' +
        '“Zugegebenermaßen hatte ich vom hybriden Closed-Loop System vorher noch nichts gehört, aber als meine beiden Kinder davon erfuhren, dass ich meinen Diabetes über mein Smartphone manage, haben sie sich kaputtgelacht! Vor der Studie erschöpften sich meine Telefonkenntnisse darin, es anzuschalten, einen Anruf zu tätigen und es auszuschalten. Aber tatsächlich konnte ich mit Unterstützung des sehr kompetenten klinischen Teams in meinem Krankenhaus ganz gut mit dem Smartphone und der CamAPS FX App umgehen. Deren Fähigkeit, einfach den Diabetes zu kontrollieren und zu behandeln, ist enorm und befreiend.” ' +
        '    </i> ' +
        '</p> ' +
        '<h3> ' +
        '    Völlig diskret ' +
        '</h3> ' +
        '<p> ' +
        'Seit Einsatz der CamAPS FX App hat Roger sein Bolusinsulin reduziert und eine Reduktion der erforderlichen Insulinmenge pro Tag erlebt. Aber Roger hat auch anderen Nutzen gesehen.  ' +
        '</p> ' +
        '<p> ' +
        '    <i> ' +
        '“Wenn wir jetzt Essen gehen, ist das einzige, was ich tun muss, mein Smartphone herauszunehmen, die Kohlenhydratmenge einzugeben und los geht es. Ich kann meine Werte sofort sehen und ich kann alles, was zu tun ist, über das Smartphone erledigen. Bevor ich die App hatte, musste ich Nadeln und Insulin mitnehmen und zur Toilette gehen, um einen Fingerstichtest durchzuführen und Injektionen, falls nötig. Um das alles wird sich nun völlig diskret gekümmert.” ' +
        '    </i> ' +
        '</p> ' +
        '<p> ' +
        '    <i> ' +
        '“Eine andere Zeit, in der wir von der App profitierten, war der Beginn der COVID-19 Pandemie, als sich die Dinge zum Schlechten wendeten. Ich fürchtete das Schlimmste, aber die App las meine Blutzuckerwerte kontinuierlich aus, was eine große Beruhigung war. Einmal schlief ich ein und meine Frau hatte Sorge, ich könnte in ein diabetisches Koma fallen, aber sie hat in aller Stille während ich schlief meine Blutzuckerwerte auf meinem Phone geprüft, und sie konnte sehen, dass alles in Ordnung war. Die App gibt innere Ruhe, was ein Nutzen ist, der sowohl meine Lebensqualität als auch die meiner Frau erhöht.”' +
        '    </i> ' +
        '</p> ' +
        '<p> ' +
        'Das Gefühl von Sicherheit und Diskretion haben nicht nur Roger und seine Frau erlebt. Studien zeigen, dass die CamAPS FX App Menschen hilft, sich vom Diabetes weniger belastet zu fühlen und ein flexibleres und spontaneres Leben zu führen. ' +
        '</p> ' +
        '<p> ' +
        'Nutzer rechneten der App ebenfalls an, dass sie als Sicherheitsnetz fungiert und einen Level an Reaktivität hat, die über ihre eigenen Fähigkeiten hinausgeht. Jedoch können Nutzer sich über die App hinwegsetzen, wenn sie die Therapie verringern oder verstärken möchten, weil physiologische Notwendigkeiten wie beispielsweise Sport oder Krankheit es erfordern.' +
        '</p> ' +
        '<p> ' +
        '    <i> ' +
        '“Es ist erstaunlich, wie sehr sich die Behandlung seit meiner Diagnose verändert hat, ich habe wirklich den Eindruck, dass ich von der Wüste in die digitale Welt gekommen bin. Für jeden, der den Einsatz der CamAPS FX App in Erwägung zieht, ist meine Empfehlung sehr einfach: Tu es! Es ist wirklich umwälzend, und wenn ich es kann, kann es jeder.” ' +
        '    </i> ' +
        '</p>'

};

/**
 * Texts for Amanda McLaren's review (list, home slider, and detail article)
 */
export const amandaReviewText = {
    title: 'Amanda McLaren - CamAPS FX',
    titleMeta: 'Lesen Sie Amanda McLarens Erfahrungsbericht zu CamAPS FX in Neuseeland',
    descriptionMeta: 'Amanda McLaren berichtet, wie CamAPS FX mit ihrer YpsoPump und dem FreeStyle Libre 3+, ' +
        'seit der öffentlichen Finanzierung in Neuseeland im Jahr 2024, weniger Hypoglykämien, ruhigere Blutzuckerwerte, einen niedrigeren HbA1c und mehr Gelassenheit nach 55 Jahren mit Typ-1-Diabetes ermöglicht hat.',
    keywords:
        'camaps review Amanda McLaren, camaps fx review Amanda McLaren, ' +
        '',
    localeMeta: 'de_de',

    imageTitle: 'Amanda McLaren',
    shortIntroAndBody:
        '<h2>Weniger Zeit mit Injektionen bedeutet mehr Freiheit.</h2>' +
        '<p>' +
        '    Mit 60 Jahren lebt Amanda McLaren seit 55 Jahren mit Typ-1-Diabetes. ' +
        '    Seit Oktober 2024 nutzt sie CamAPS FX zusammen mit ihrer YpsoPump und ' +
        '    dem FreeStyle Libre 3+, seit die Kosten in Neuseeland öffentlich übernommen werden. ' +
        '    Seither hat sie weniger Hypoglykämien und einen deutlich leichter zu bewältigenden Alltag.' +
        '</p>',
    body:
        '<h2>Weniger Zeit mit Injektionen bedeutet mehr Freiheit.</h2> ' +
        '<p> ' +
        '    <strong> ' +
        '    Mit 60 Jahren lebt Amanda McLaren seit 55 Jahren mit Typ-1-Diabetes. Seit Oktober 2024 nutzt sie ' +
        '    CamAPS FX mit ihrer YpsoPump und dem FreeStyle Libre 3+, seit die Therapie in Neuseeland öffentlich finanziert wird. ' +
        '    Seither hat sie weniger Hypoglykämien und einen deutlich leichter zu bewältigenden Alltag. ' +
        '    </strong> ' +
        '</p> ' +
        '<p> ' +
        '    Die Diagnose erhielt sie am 13. April 1972; in den frühen Jahren war das Management weitgehend ein Ratespiel, und ' +
        '    selbst mit häuslicher Blutzuckerkontrolle machten ständige Fingerstiche die Finger wund, und zu große oder zu kleine Bolusse waren häufig. ' +
        '    Der FreeStyle Libre 2 half, aber bis zu zehn Injektionen pro Tag waren zeitaufwändig und oft schwierig. ' +
        '</p> ' +
        '<p> ' +
        '    Amanda hatte zudem nächtliche Hypoglykämien und ein Dawn-Phänomen, was den Schlaf beeinträchtigte und die Morgen erschöpfend machte. ' +
        '    Ein besserer Umgang mit ihrer Erkrankung war entscheidend für ihr seelisches und körperliches Wohlbefinden und um das Komplikationsrisiko zu senken. ' +
        '</p> ' +
        '<p> ' +
        '    Der Einstieg in CamAPS FX war unkompliziert, erzählt Amanda: ' +
        '    <i>„Ich hatte ein großartiges Team an meiner Seite und fand es einfach.“</i> ' +
        '</p> ' +
        '<p> ' +
        '    Die App hat viele Entscheidungen abgenommen; kontinuierliche Basal-Anpassungen halten den Blutzucker ruhiger. Sie erklärt: ' +
        '    <i>„Es sind viel weniger Eingriffe nötig. Abgesehen vom Eintragen der Mahlzeiten muss ich mir im Grunde keine Sorgen mehr machen.“</i> ' +
        '</p> ' +
        '<p> ' +
        '    Seit CamAPS FX ist Amandas HbA1c niedriger, die Blutzuckerschwankungen seltener, das Dawn-Phänomen verschwunden ' +
        '    und nächtliche Hypoglykämien treten viel seltener auf. Nicht jedes Detail ihrer Typ-1-Diabetes mikromanagen zu müssen, ist eine große Erleichterung. ' +
        '</p> ' +
        '<p> ' +
        '    Amanda sagt: ' +
        '    <i>„Weniger Zeit mit Injektionen befreit. Bessere Kontrolle gibt mir mehr Ruhe.“</i> ' +
        '    Sorgen um zu hohe oder zu niedrige Werte nehmen deutlich weniger Raum ein – das gibt ihr mehr Freiheit und Selbstvertrauen im Alltag. ' +
        '</p> ' +
        '<p> ' +
        '    Rückblickend fasst sie zusammen: ' +
        '    <i>„Nach einer anfänglichen Eingewöhnungsphase, in der die App mich kennenlernte und ich lernte, ihr bei der Steuerung meiner Therapie zu vertrauen, ' +
        '    sind so viele Sorgen und Entscheidungen weggefallen. Die App ist einfach zu bedienen und hat mein Leben verändert.“</i> ' +
        '</p>',
};


/**
 * Texts for Christopher Salter's review (list, home slider, and detail article)
 */
export const christopherReviewText = {
    title: 'Christopher Salter - CamAPS FX',
    titleMeta: 'Lesen Sie Christopher Salters Erfahrungsbericht zu CamAPS FX',
    descriptionMeta: 'Christopher Salter berichtet, wie CamAPS FX mit seiner YpsoPump und dem FreeStyle Libre 3 Plus nach mehr als drei Jahrzehnten mit Typ-1-Diabetes Zeit im Zielbereich, HbA1c und den Alltag verbessert hat.',
    keywords:
        'camaps Rezension Christopher Salter, camaps fx Rezension Christopher Salter, ' +
        '',
    localeMeta: 'de_de',

    imageTitle: 'Christopher Salter',
    shortIntroAndBody:
        '<h2>So stelle ich mir vor, wie es sich für einen Nicht-Diabetiker ungefähr anfühlen würde</h2>' +
        '<p>' +
        '    Für Christopher Salter ist das Leben mit Typ-1-Diabetes eine lebenslange Erfahrung, die seinen Alltag seit der Diagnose mit nur zwei Jahren stark geprägt hat. Mit 36 hat er mehr als drei Jahrzehnte damit verbracht, die Herausforderungen einer oft unberechenbaren und anspruchsvollen Erkrankung zu bewältigen.' +
        '</p>',
    body:
        '<h2>So stelle ich mir vor, wie es sich für einen Nicht-Diabetiker ungefähr anfühlen würde</h2> ' +
        '<p> ' +
        '    <strong> ' +
        '    Für Christopher Salter ist das Leben mit Typ-1-Diabetes eine lebenslange Erfahrung, die seinen Alltag seit der Diagnose mit nur zwei Jahren stark geprägt hat. Mit 36 hat er mehr als drei Jahrzehnte damit verbracht, die Herausforderungen einer oft unberechenbaren und anspruchsvollen Erkrankung zu bewältigen. ' +
        '    </strong> ' +
        '</p> ' +
        '<p> ' +
        '    Seine Blutzuckerwerte waren häufig schwer zu stabilisieren, und regelmäßige Hypoglykämien machten den Alltag stressig und erschöpfend. Vor dem Einsatz moderner Technologie beschreibt Chris sein Diabetes-Management als <i>„sehr stressig und zeitaufwändig“</i>, wobei er viel Energie darauf verwendete, Hypoglykämien zu vermeiden und zu behandeln. ' +
        '</p> ' +
        '<p> ' +
        '    Diese Herausforderungen gingen über die körperliche Gesundheit hinaus. In der Schule wurden Episoden oft vor Mitschülern behandelt, was ihn exponiert fühlen ließ; später fiel es ihm schwer, seine Erkrankung anderen zu erklären, was Beziehungen und Selbstvertrauen beeinträchtigte. Mit der Zeit führte der ständige Druck zu Burnout und einem wachsenden Rückzug von seiner Typ-1-Diabetes-Versorgung. ' +
        '</p> ' +
        '<p> ' +
        '    Nach einem DAFNE-Kurs empfahl seine Diabetes-Schwester CamAPS FX, um die tägliche Belastung zu verringern. Er nutzt das System seit etwa drei Jahren zusammen mit der YpsoPump und dem FreeStyle Libre 3 Plus. Obwohl die Finanzierung Geduld erforderte, empfand er Schulung und Einrichtung als reibungslos, sobald alles bereitstand. ' +
        '</p> ' +
        '<p> ' +
        '    Die Wirkung war deutlich. Seit CamAPS FX hat Chris spürbare Verbesserungen bei Zeit im Zielbereich, HbA1c und insgesamt stabilerer Glukose. Hypoglykämien – besonders nachts und bei der Arbeit – sind deutlich seltener, und seine Schlafqualität hat sich verbessert. ' +
        '</p> ' +
        '<p> ' +
        '    Am wichtigsten hat das System verändert, wie er sich täglich fühlt. Mit weniger ständigen Entscheidungen fühlt er sich entspannter und kontrollierter, die mentale Belastung ist geringer. Chris sagt: <i>„CamAPS FX ist für mich bisher das Nächste daran, kein Diabetiker zu sein – so stelle ich mir vor, wie es sich für einen Nicht-Diabetiker ungefähr anfühlen würde.“</i> ' +
        '</p> ' +
        '<p> ' +
        '    Chris nutzt CamAPS FX weiter und sieht es als wesentlichen Teil seiner Langzeitversorgung. Er würde es anderen empfehlen – nicht nur wegen der klinischen Verbesserungen, sondern auch wegen des wiedererlangten Gefühls von Normalität und Selbstvertrauen. ' +
        '</p>',
};


/**
 * Texts for Alice Hibbert-Davies review article
 */
export const aliceReviewText = {
    title: 'Alice Hibbert-Davies - CamAPS FX',
    titleMeta: 'Read Alice Hibbert-Davies\' review of CamAPS FX',
    descriptionMeta: 'Alice Hibbert-Davies shares how the myLoop system with CamAPS FX transformed her type 1 diabetes ' +
        'management and helped her conquer Mount Kilimanjaro.',
    keywords:
        'camaps review Alice Hibbert-Davies, camaps fx review Alice Hibbert-Davies, myLoop CamAPS FX, ' +
        '',
    localeMeta: 'en_gb',

    imageTitle: 'Alice Hibbert-Davies',
    shortIntroAndBody:
        '<h2>From managing T1D to conquering Mount Kilimanjaro.</h2>' +
        '<p>' +
        '    Alice Hibbert-Davies is reaching new heights with the help of the myLoop system with CamAPS FX, which she ' +
        '    credits with transforming her diabetes management and giving her greater freedom to embrace life\'s ' +
        '    biggest adventures.' +
        '</p>',
    body:
        '<h2>From managing type 1 diabetes to conquering the summit of Mount Kilimanjaro.</h2> ' +
        '<p> ' +
        '    <strong> ' +
        '    Alice Hibbert-Davies is reaching new heights with the help of the myLoop system with CamAPS FX, which she ' +
        '    credits with transforming her diabetes management and giving her greater freedom to embrace life\'s ' +
        '    biggest adventures. ' +
        '    </strong> ' +
        '</p> ' +
        '<p> ' +
        '    Alice was diagnosed with type 1 diabetes when she was 18 after experiencing symptoms including increased ' +
        '    thirst, weight loss and passing urine more frequently. She was already familiar with the condition as her ' +
        '    younger sister had been diagnosed with type 1 diabetes a few years earlier at the age of 13. ' +
        '</p> ' +
        '<p> ' +
        '    Alice quickly contacted her doctor with the suspicion she had type 1 diabetes but despite her prior ' +
        '    knowledge and experience of the condition, she said it still came as a shock when she was diagnosed. ' +
        '</p> ' +
        '<p> ' +
        '    Alice said: ' +
        '    <i>“Even though I thought I had type 1 diabetes, when I was told I still thought, ‘Oh my gosh, why has ' +
        '    this happened to me?’</i> ' +
        '</p> ' +
        '<p> ' +
        '    <i>“It was still a massive shock and difficult to take in all the information – I found it overwhelming.”</i> ' +
        '</p> ' +
        '<p> ' +
        '    Alice was in her first year of studying for a degree in wildlife conservation but was living at home, ' +
        '    which she said made it a little easier for her to navigate the early days following her diagnosis. ' +
        '</p> ' +
        '<p> ' +
        '    <i>“To begin with, it was a massive change to how I live and trying to work out how managing my diabetes ' +
        '    would fit into my life – all the decision making and checking my levels,”</i> Alice said. ' +
        '</p> ' +
        '<p> ' +
        '    For the first year following her diagnosis, Alice manually injected insulin but jumped at the chance of ' +
        '    using a closed-loop system when it was offered to her. ' +
        '</p> ' +
        '<p> ' +
        '    Alice, who is 22 and lives in Bath, said opting for the closed loop system was ' +
        '    <i>“one of the best decisions I have ever made”</i>. ' +
        '</p> ' +
        '<p> ' +
        '    She said: ' +
        '    <i>“I was drawn to the YpsoPump with CamAPS FX because of the flexibility it gives me. I’d heard from ' +
        '    other people how much easier it made managing their condition. The main draw was the pre-filled insulin ' +
        '    vials and how it is approved for use in pregnancy, which is good to know for the future.”</i> ' +
        '</p> ' +
        '<p> ' +
        '    A part-time gymnastics coach and regular hiker, Alice said she is grateful for CamAPS for allowing her ' +
        '    to continue to pursue an active lifestyle. ' +
        '</p> ' +
        '<p> ' +
        '    <i>“CamAPS is very straightforward to use in terms of inputting things like carbs and hypo snacks,”</i> ' +
        '    she said. ' +
        '</p> ' +
        '<p> ' +
        '    <i>“I’m always impressed by it. I have a very busy lifestyle and my daily routine is different every day ' +
        '    of the week, but it always manages to keep my level in range, even when I’m waking up at different times ' +
        '    and eating meals at different times of the day.</i> ' +
        '</p> ' +
        '<p> ' +
        '    <i>“It’s that peace of mind, knowing it’s working and keeping me in range. It just takes away some of ' +
        '    the extra stress of having diabetes.”</i> ' +
        '</p> ' +
        '<p> ' +
        '    Alice, who is currently studying for a PhD in herpetology, the study of reptiles and amphibians, climbed ' +
        '    Mount Kilimanjaro in September 2026, using the challenge to raise awareness of type 1 diabetes and inspire ' +
        '    others who have been diagnosed. ' +
        '</p> ' +
        '<p> ' +
        '    She said: ' +
        '    <i>“Having type 1 diabetes doesn’t have to stop you. You can still live the life you want.”</i> ' +
        '</p>',
};
